// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container-main {
  background-color: #007bffab;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.agent-title {
  font-size: 24px;
  font-weight: lighter;
  color: #333;
  margin-bottom: 10px;
}

.agent-description {
  font-size: 16px;
  padding: 1em;
  color: #666;
  margin-bottom: 15px;
  font-weight: lighter;
  border-bottom: 1px solid rgba(0, 0, 0, 0.349);
}

.chat-container {
  padding: 1rem;
  height: 100vh;
  display: flex;
  color: rgb(39, 39, 39);
  border-bottom: #9b9b9b;
  flex-direction: column;
  justify-content: flex-end;
  transition: margin-left 0.3s ease;
  
}

.chat-box {
  border-radius: 15px;
  background-color: #eaeaea;
  padding: 1rem;
  max-height: 70%;
  overflow-y: auto;
  border: 1px solid #ccc;
  margin-bottom: 1rem;
  margin-right: 17%;
}

.chat-input {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chat-input input {
  background-color: #ffffff;
  border-radius: 15px;
  height: 4%;
  padding: 0.5rem;
  border: 1px solid #ffffff;
  margin-bottom: 350px;
  
}

.chat-input button {
  padding: 0.5rem 1rem;
  height: 7%;
  border-radius: 15px;
  border: 1px solid #ffffff;
  background-color: #e8e9eb;
  color: rgb(70, 70, 70);
  border: none;
  margin-bottom: 350px;
}

.agent {
  margin-top: 70px;
}

.content-container.panel-visible .chat-container {
  margin-left: 220px;
}

.content-container.panel-hidden .chat-container {
  margin-left: 0;
}

@media only screen and (max-width: 1300px) {
  .chat-container {
    margin-top: 10%;
  }
}

@media only screen and (max-width: 1000px) {
  .chat-container {
    margin-top: 20%;
  }
}

@media only screen and (max-width: 750px) {
  .chat-container {
    width: 80vw;
    max-width: 100%;
  }

  .content-container.panel-visible .chat-container {
    margin-left: 43px;
  }

  .agent-description {
    font-size: 14px;
    padding: 0.5em;
    color: #666;
    margin-bottom: 15px;
    font-weight: lighter;
    border-bottom: 1px solid rgba(0, 0, 0, 0.349);
  }

  .chat-input {
    flex-direction: column;
  }

  .chat-input input {
    margin-bottom: 0px;
    margin-right: 50%;
  }

  .chat-input button {
    height: 7%;
    margin-right: 75%;
  }
}

@media only screen and (max-width: 400px) {


  .chat-input input {
    margin-bottom: 0px;
    margin-right: 30%;
  }

  .chat-input button {
    height: 7%;
    margin-right: 65%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pages-style/agent.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;;AAEnC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,oBAAoB;;AAEtB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;;;EAGE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF","sourcesContent":[".content-container-main {\n  background-color: #007bffab;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.agent-title {\n  font-size: 24px;\n  font-weight: lighter;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.agent-description {\n  font-size: 16px;\n  padding: 1em;\n  color: #666;\n  margin-bottom: 15px;\n  font-weight: lighter;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.349);\n}\n\n.chat-container {\n  padding: 1rem;\n  height: 100vh;\n  display: flex;\n  color: rgb(39, 39, 39);\n  border-bottom: #9b9b9b;\n  flex-direction: column;\n  justify-content: flex-end;\n  transition: margin-left 0.3s ease;\n  \n}\n\n.chat-box {\n  border-radius: 15px;\n  background-color: #eaeaea;\n  padding: 1rem;\n  max-height: 70%;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  margin-bottom: 1rem;\n  margin-right: 17%;\n}\n\n.chat-input {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.chat-input input {\n  background-color: #ffffff;\n  border-radius: 15px;\n  height: 4%;\n  padding: 0.5rem;\n  border: 1px solid #ffffff;\n  margin-bottom: 350px;\n  \n}\n\n.chat-input button {\n  padding: 0.5rem 1rem;\n  height: 7%;\n  border-radius: 15px;\n  border: 1px solid #ffffff;\n  background-color: #e8e9eb;\n  color: rgb(70, 70, 70);\n  border: none;\n  margin-bottom: 350px;\n}\n\n.agent {\n  margin-top: 70px;\n}\n\n.content-container.panel-visible .chat-container {\n  margin-left: 220px;\n}\n\n.content-container.panel-hidden .chat-container {\n  margin-left: 0;\n}\n\n@media only screen and (max-width: 1300px) {\n  .chat-container {\n    margin-top: 10%;\n  }\n}\n\n@media only screen and (max-width: 1000px) {\n  .chat-container {\n    margin-top: 20%;\n  }\n}\n\n@media only screen and (max-width: 750px) {\n  .chat-container {\n    width: 80vw;\n    max-width: 100%;\n  }\n\n  .content-container.panel-visible .chat-container {\n    margin-left: 43px;\n  }\n\n  .agent-description {\n    font-size: 14px;\n    padding: 0.5em;\n    color: #666;\n    margin-bottom: 15px;\n    font-weight: lighter;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.349);\n  }\n\n  .chat-input {\n    flex-direction: column;\n  }\n\n  .chat-input input {\n    margin-bottom: 0px;\n    margin-right: 50%;\n  }\n\n  .chat-input button {\n    height: 7%;\n    margin-right: 75%;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n\n\n  .chat-input input {\n    margin-bottom: 0px;\n    margin-right: 30%;\n  }\n\n  .chat-input button {\n    height: 7%;\n    margin-right: 65%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
